import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.machine.machine');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-machine-machine',
template: templateSource || '',
    styles: [``],
})
export class PortalMachineMachineComponent implements OnInit {

    @Input() farmId: string = '';

    public machines:any[] = [];
    public selectedMachine:any = null;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();

        await this.loadMachines();

        await this.service.render();
    }

    private async loadMachines() {

        const { code, data } = await wiz.call('machines', { farm_id: this.farmId || '' });

        if (code === 200 && data) {

            this.machines = data.map((m:any) => {
                try { m.machine_condition = JSON.parse(m.machine_condition); } catch {}
                try { m.tray = JSON.parse(m.tray); } catch {}
                return m;
            });

            if (this.machines.length > 0) {
                this.selectedMachine = this.machines[0];
            }
        }
    }

    public async selectMachine(item:any) {
        this.selectedMachine = item;
        await this.service.render();
    }
}

export default PortalMachineMachineComponent;